import { diagnosisCode } from "dto/encounter.dto";
import dxInterceptionApi from "services/dxInterception.api";

const getDiagnosisCode = async (
    transactionNumber: string,
    hospitalNumber: string,
    service: string
) => {
    return dxInterceptionApi.get<diagnosisCode>(
        `/diagnosisCode/${transactionNumber}/${hospitalNumber}/${service}`
    );
};

const diagnosisCodeService = { getDiagnosisCode };

export default diagnosisCodeService;
